// extracted by mini-css-extract-plugin
export default {"tr":"CompetitorTable_tr__AZ7u2","tbody":"CompetitorTable_tbody__vqRw4","mobileitems":"CompetitorTable_mobileitems__FXaeF","mobileitem":"CompetitorTable_mobileitem__q5hdg"};